import PropTypes from 'prop-types';
import { Component } from 'react';
import { OrderedMap } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import connect from 'SalesContentIndexUI/data/redux/connect';
import identity from 'transmute/identity';
import { getLocationQuery } from 'SalesContentIndexUI/data/utils/router';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import SearchStatusPropType from 'SalesContentIndexUI/propTypes/SearchStatusPropType';
import SearchQueryRecord from 'SalesContentIndexUI/data/records/SearchQueryRecord';
import SearchSortRecord from 'SalesContentIndexUI/data/records/SearchSortRecord';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchViewFilterRecord from 'SalesContentIndexUI/data/records/SearchViewFilterRecord';
import { INITIALIZING, LOADING, EMPTY, ERROR } from 'SalesContentIndexUI/data/constants/TableContentState';
import TableContentStatePropType from 'SalesContentIndexUI/data/constants/TableContentStatePropType';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import * as SelectionActions from 'SalesContentIndexUI/data/actions/SelectionActions';
import { calculateTotalPages, selectSearchResultsForCurrentPage
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
} from 'SalesContentIndexUI/data/redux/selectors/searchSelectors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import { selectTableContentState } from 'SalesContentIndexUI/data/redux/selectors/tableStateSelectors';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexTableNavigator from 'SalesContentIndexUI/components/IndexTableNavigator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexTable from 'SalesContentIndexUI/components/IndexTable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexTablePaginator from 'SalesContentIndexUI/components/IndexTablePaginator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexErrorState from 'SalesContentIndexUI/components/IndexErrorState';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexTableZeroState from 'SalesContentIndexUI/components/zeroStates/IndexTableZeroState';
import { getFilteredTableColumns } from '../utils/getFilteredTableColumns';

// Redux state not typed yet
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const externalPropTypes = {
  SuccessMarker: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  FailureMarker: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  count: PropTypes.number,
  renderFolderTableActionButtons: PropTypes.func,
  renderSearchResultTableActionButtons: PropTypes.func,
  onViewFilterSelected: PropTypes.func,
  onTableContentStateChanged: PropTypes.func,
  onTableSearchResultsChanged: PropTypes.func,
  location: PropTypes.object,
  saveFolder: PropTypes.func,
  showNewFolderButton: PropTypes.bool,
  isDocumentsMultiBrandEnabled: PropTypes.bool
};
export default (({
  folderContentType,
  tableColumns,
  TableRow,
  FolderRow,
  EmptyState,
  isModal,
  looseItemContentType,
  useOwnerViewFilters,
  onClickNew,
  showTemplateCreateButton
}) => {
  class IndexTableContainer extends Component {
    componentDidMount() {
      if (this.props.tableContentState !== LOADING) {
        // @ts-expect-error onTableContentStateChanged may be undefined, but it is provided in defaultProps
        this.props.onTableContentStateChanged(this.props.tableContentState);
      }
      if (isModal) {
        this.props.searchFromModal({
          isInitial: true
        });
      } else {
        // @ts-expect-error Argument of type 'Location | undefined' is not assignable to parameter of type '{ search: string; }'.
        const locationQuery = getLocationQuery(this.props.location);
        this.props.searchFromQueryParams({
          queryParams: locationQuery,
          isInitial: true
        });
      }
    }
    componentDidUpdate(prevProps) {
      const {
        onTableSearchResultsChanged,
        onTableContentStateChanged,
        tableContentState,
        searchResults
      } = this.props;
      if (onTableContentStateChanged && prevProps.tableContentState !== tableContentState) {
        onTableContentStateChanged(tableContentState);
      }
      if (onTableSearchResultsChanged && prevProps.searchResults !== searchResults) {
        onTableSearchResultsChanged(searchResults);
      }
    }
    render() {
      const {
        SuccessMarker,
        FailureMarker,
        searchQuery,
        currentSort,
        selectedViewFilter,
        searchStatus,
        searchResults,
        totalPages,
        selectionData,
        selectedFolder,
        setSelectedFolder,
        renderFolderTableActionButtons,
        renderSearchResultTableActionButtons,
        onViewFilterSelected,
        setSearchQuery,
        setSort,
        setViewFilter,
        getPage,
        tableContentState,
        toggleFolderSelection,
        toggleRowSelection,
        location,
        saveFolder,
        showNewFolderButton,
        isDocumentsMultiBrandEnabled
      } = this.props;
      if (tableContentState === INITIALIZING) {
        return /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: "300px"
        });
      }
      if (tableContentState === ERROR) {
        return /*#__PURE__*/_jsx(IndexErrorState, {
          FailureMarker: FailureMarker
        });
      }
      const showTableContent = tableContentState !== EMPTY;
      const showNavigator = showTableContent || isModal;
      const filteredTableColumns = getFilteredTableColumns(tableColumns, looseItemContentType, folderContentType, isDocumentsMultiBrandEnabled);
      return /*#__PURE__*/_jsxs("div", {
        "data-test-id": "sales-content-index-table-container",
        "data-onboarding": "sales-content-index-table-container",
        children: [showNavigator && /*#__PURE__*/_jsx(IndexTableNavigator, {
          selectedViewFilterId: selectedViewFilter.id,
          selectedFolder: selectedFolder,
          searchQuery: searchQuery,
          setSearchQuery: setSearchQuery,
          setSelectedFolder: setSelectedFolder,
          setViewFilter: (viewFilter, id) => {
            setViewFilter(viewFilter, id);
            if (onViewFilterSelected) {
              onViewFilterSelected(viewFilter);
            }
          },
          isModal: isModal,
          looseItemContentType: looseItemContentType,
          useOwnerViewFilters: useOwnerViewFilters,
          location: location,
          saveFolder: saveFolder,
          showNewFolderButton: showNewFolderButton,
          onClickNew: onClickNew,
          showTemplateCreateButton: showTemplateCreateButton
        }), showTableContent ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(IndexTable, {
            SuccessMarker: SuccessMarker,
            tableColumns: filteredTableColumns,
            searchStatus: searchStatus,
            currentSort: currentSort,
            searchResults: searchResults,
            tableRow: TableRow,
            folderRow: FolderRow,
            selectionData: selectionData,
            renderFolderTableActionButtons: renderFolderTableActionButtons,
            renderSearchResultTableActionButtons: renderSearchResultTableActionButtons,
            folderContentType: folderContentType,
            setSearchQuery: setSearchQuery,
            setSort: setSort,
            setSelectedFolder: setSelectedFolder,
            toggleFolderSelection: toggleFolderSelection,
            toggleRowSelection: toggleRowSelection,
            isModal: isModal
          }), /*#__PURE__*/_jsx(IndexTableZeroState, {
            SuccessMarker: SuccessMarker,
            selectedViewFilter: selectedViewFilter,
            totalPages: totalPages,
            searchQuery: searchQuery,
            searchResults: searchResults,
            searchStatus: searchStatus,
            looseItemContentType: looseItemContentType
          }), /*#__PURE__*/_jsx(IndexTablePaginator, {
            searchQuery: searchQuery,
            totalPages: totalPages,
            searchStatus: searchStatus,
            getPage: getPage
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SuccessMarker, {}), /*#__PURE__*/_jsx(EmptyState, {})]
        })]
      });
    }
  }
  IndexTableContainer.propTypes = Object.assign({}, externalPropTypes, {
    searchQuery: PropTypes.instanceOf(SearchQueryRecord).isRequired,
    currentSort: PropTypes.instanceOf(SearchSortRecord),
    selectedViewFilter: PropTypes.instanceOf(SearchViewFilterRecord).isRequired,
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof OrderedMap' is not assign... Remove this comment to see the full error message
    searchResults: PropTypes.instanceOf(OrderedMap).isRequired,
    searchStatus: SearchStatusPropType.isRequired,
    selectionData: PropTypes.object.isRequired,
    selectedFolder: PropTypes.instanceOf(SearchResultRecord),
    totalPages: PropTypes.number.isRequired,
    searchFromModal: PropTypes.func.isRequired,
    searchFromQueryParams: PropTypes.func.isRequired,
    setSearchQuery: PropTypes.func.isRequired,
    setSort: PropTypes.func.isRequired,
    setSelectedFolder: PropTypes.func.isRequired,
    setViewFilter: PropTypes.func.isRequired,
    getPage: PropTypes.func.isRequired,
    toggleFolderSelection: PropTypes.func.isRequired,
    toggleRowSelection: PropTypes.func.isRequired,
    tableContentState: TableContentStatePropType.isRequired
  });
  IndexTableContainer.defaultProps = {
    onTableContentStateChanged: identity,
    onTableSearchResultsChanged: identity,
    SuccessMarker: () => null,
    FailureMarker: () => null
  };
  return connect(({
    search,
    selectionData
  }, {
    count
  }) => {
    return {
      searchQuery: search.searchQuery,
      currentSort: search.currentSort,
      selectedViewFilter: search.selectedViewFilter,
      searchResults: selectSearchResultsForCurrentPage(search),
      searchStatus: search.searchStatus,
      totalPages: calculateTotalPages(search),
      selectedFolder: search.selectedFolder,
      selectionData,
      tableContentState: selectTableContentState(count)(search)
    };
  }, SelectionActions)(IndexTableContainer);
});

// Types